import React from 'react';
export function GuaranteeSection() {
  return <section className="w-full bg-bg-main py-20 px-4" data-id="element-113">
      <div className="max-w-4xl mx-auto" data-id="element-114">
        <div className="bg-white border border-border-light shadow-[0_8px_30px_rgba(201,137,155,0.08)] rounded-3xl p-10 sm:p-16 text-center relative overflow-hidden" data-id="element-115">
          <div className="w-20 h-20 mx-auto bg-bg-alt border border-border-light rounded-full flex items-center justify-center mb-6" data-id="element-116">
            <span className="text-4xl" data-id="element-117">🛡️</span>
          </div>

          <h2 className="text-2xl sm:text-4xl font-serif font-black text-text-main mb-6 tracking-tight" data-id="element-118">
            RECUPERA IL TUO TEMPO O TI RIMBORSIAMO
          </h2>

          <p className="text-text-sec text-base sm:text-lg leading-relaxed max-w-2xl mx-auto" data-id="element-119">
            Siamo così sicuri dell'efficacia del Pilates Elite Bundle che ti
            offriamo{' '}
            <span className="text-primary font-bold" data-id="element-120">
              14 giorni per provarlo
            </span>
            . Se non sentirai che il tuo lavoro come istruttrice è diventato più
            semplice e fluido, ti restituiremo il 100% dei tuoi soldi. Senza
            domande.
          </p>
        </div>
      </div>
    </section>;
}